import {LoginStore, SubscriptionStore, PageStore} from '../../stores';
import {Redirect, withRouter} from 'react-router';

import {Link} from 'react-router-dom';
import LoadScreen from '../../components/loadScreen/LoadScreen';
import { LoginActions } from '../../actions';
import Message from '../../components/message/Message';
import PropTypes from 'prop-types';
import React from 'react';
import SubscriptionActions from '../../actions/SubscriptionActions';
import {connectToStores} from 'epic-alt-utils/index';
import {generateRoutePath} from 'epic-common/src/route';

@connectToStores
class SuccessView extends React.Component {
    static propTypes = {
        loginStore: PropTypes.object,
        subscriptionStore: PropTypes.object,
        pageStore: PropTypes.object
    };

    static getStores() {
        return [SubscriptionStore, LoginStore, PageStore];
    }

    static getPropsFromStores() {
        return {
            loginStore: LoginStore.getState(),
            subscriptionStore: SubscriptionStore.getState(),
            pageStore: PageStore.getState()
        };
    }

    static getInitialActions() {
        return [
            (props) => {
                const {loginStore, subscriptionStore} = props;
                if (!loginStore.isLoggedIn) {
                    return LoginActions.requestLogin('/beta-sign-up');
                }
                const {email} = loginStore.accountInfo;
                if (email && !subscriptionStore.isSubscribed) {
                    SubscriptionActions.getOptOutLink.defer();
                    SubscriptionActions.subscribe.defer(email);
                }
            }
        ];
    }

    render() {
        // Utilized signup-thank-you page in cms.
        const {loginStore: {isLoggedIn}, pageStore: {successData}} = this.props;
        if (!isLoggedIn) {
            return <Redirect to={generateRoutePath("/home")} />
        }
        const {optOutLink, loading} = this.props.subscriptionStore;
        return (
            <div className="beta-sign-up-page">
                <LoadScreen show={loading} />
                <h2><Message code={successData.title1}/></h2>
                <h2><Message code={successData.title2}/></h2>
                {//eslint-disable-next-line react/no-danger
                }<div dangerouslySetInnerHTML={{__html: successData.content.replace(/\{0\}/, optOutLink)}} />
                <div className="home-button">
                    <Link to={generateRoutePath('/home')}>
                        <Message code="epic.spyjinx.common.home_page"/>
                    </Link>
                </div>
            </div>
        );
    }
}

export default withRouter(SuccessView);
